/**
 * Normalises any thrown value to a string message (null when nullish).
 * Used for analytics error payloads and CDN-fallback diagnostics.
 */
export const errorMessage = (error: unknown): string | null => {
  if (error instanceof Error) return error.message;
  if (error == null) return null;
  return String(error);
};
